<div *ngIf="isLoading">
  <div class="text-center">
    <ap-spinner size="2"></ap-spinner>
  </div>
</div>

<table class="table emds-table table-sticky-header table-striped" *ngIf="!isLoading" [formGroup]="securityTabFormGroup">
  <thead>
    <tr>
      <th translate>User or User Group</th>
      <th *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsReadOnlyAllowed" translate>Read Only</th>
      <th *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsSelectAllowed" translate>Select</th>
      <th *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsCreateAllowed" translate>New</th>
      <th *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsModifyAllowed" translate>Modify</th>
      <th *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsDeleteAllowed" translate>Merge/Delete</th>
      <th *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsAllowed" translate>Allow</th>
      <th *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsCompleteAllowed" translate>Complete</th>
      <th *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsOverrideAllowed" translate>Override</th>
      <th *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsEveryoneFiltersAllowed" translate>Everyone</th>
      <th *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsWarnAllowed" translate>Warn</th>
      <th></th>
    </tr>
  </thead>
  <tbody formArrayName="securityUserGroupsFormArray">
    <tr *ngFor="let securityUserGroupForm of securityUserGroupsFormArray.controls; let i = index" [formGroup]="securityUserGroupForm">
      <td>
        <div id="{{Id}}-user-usergroup-{{i}}">
          <ap-findcontrol [baseId]="Id + '-' + i + '-user-or-usergroup'"
            [findControlId]="findControlIdService.ViewUserAndUserGroup"
            [(selectedPk)]="userOrUserGroupIds[i]"
            [findControlDisplayName]="'User or User Group'"
            [apFormGroup]="securityUserGroupForm"
            [controlName]="'userOrUserGroupFormControl' + i"
            [singleSelect]="true"
            [form]="form"
            [required]="true">
          </ap-findcontrol>
        </div>
      </td>
      <td *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsReadOnlyAllowed">
        <div class="td-center">
          <mat-checkbox id="{{Id}}-read-only-{{i}}"
            formControlName="isReadOnlySelectedFormControl"
            (change)="securityCheckboxChanged(securityUserGroupForm, 'isReadOnlySelectedFormControl')">
          </mat-checkbox>
        </div>
      </td>
      <td *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsSelectAllowed">
        <div class="td-center">
          <mat-checkbox id="{{Id}}-selected-{{i}}"
            formControlName="isSelectSelectedFormControl"
            (change)="securityCheckboxChanged(securityUserGroupForm, 'isSelectSelectedFormControl')">
          </mat-checkbox>
        </div>
      </td>
      <td *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsCreateAllowed">
        <div class="td-center">
          <mat-checkbox id="{{Id}}-new-{{i}}"
            formControlName="isNewSelectedFormControl"
            (change)="securityCheckboxChanged(securityUserGroupForm, 'isNewSelectedFormControl')">
          </mat-checkbox>
        </div>
      </td>
      <td *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsModifyAllowed">
        <div class="td-center">
          <mat-checkbox id="{{Id}}-modify-{{i}}"
            formControlName="isModifySelectedFormControl"
            (change)="securityCheckboxChanged(securityUserGroupForm, 'isModifySelectedFormControl')">
          </mat-checkbox>
        </div>
      </td>
      <td *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsDeleteAllowed">
        <div class="td-center">
          <mat-checkbox id="{{Id}}-delete-{{i}}"
            formControlName="isDeleteSelectedFormControl"
            (change)="securityCheckboxChanged(securityUserGroupForm, 'isDeleteSelectedFormControl')">
          </mat-checkbox>
        </div>
      </td>
      <td *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsAllowed">
        <div class="td-center">
          <mat-checkbox id="{{Id}}-allow-{{i}}"
            formControlName="isAllowSelectedFormControl"
            (change)="securityCheckboxChanged(securityUserGroupForm, 'isAllowSelectedFormControl')">
          </mat-checkbox>
        </div>
      </td>
      <td *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsCompleteAllowed">
        <div class="td-center">
          <mat-checkbox id="{{Id}}-complete-{{i}}"
            formControlName="isCompleteSelectedFormControl"
            (change)="securityCheckboxChanged(securityUserGroupForm, 'isCompleteSelectedFormControl')">
          </mat-checkbox>
        </div>
      </td>
      <td *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsOverrideAllowed">
        <div class="td-center">
          <mat-checkbox id="{{Id}}-override-{{i}}"
            formControlName="isOverrideSelectedFormControl"
            (change)="securityCheckboxChanged(securityUserGroupForm, 'isOverrideSelectedFormControl')">
          </mat-checkbox>
        </div>
      </td>
      <td *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsEveryoneFiltersAllowed">
        <div class="td-center">
          <mat-checkbox id="{{Id}}-everyone-{{i}}"
            formControlName="isEveryoneFiltersSelectedFormControl"
            (change)="securityCheckboxChanged(securityUserGroupForm, 'isEveryoneFiltersSelectedFormControl')">
          </mat-checkbox>
        </div>
      </td>
      <td *ngIf="findControlBehaviorSecurity?.SecurityPermissions?.IsWarnAllowed">
        <div class="td-center">
          <mat-checkbox id="{{Id}}-warn-{{i}}"
            formControlName="isWarnSelectedFormControl"
            (change)="securityCheckboxChanged(securityUserGroupForm, 'isWarnSelectedFormControl')">
          </mat-checkbox>
        </div>
      </td>
      <td>
        <div class="td-center">
          <mat-icon class="clickable" (click)="deleteRow(i)">close</mat-icon>
        </div>
      </td>
    </tr>
  </tbody>
</table>
<mat-icon class="clickable" (click)="addRow()">add_circle</mat-icon>
